<script>
import 'chartjs-adapter-moment'
import { Doughnut, mixins } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels'

/**
 * График - линия.
 */
export default {
  name: 'CDoughnutChart',
  extends: Doughnut,
  mixins: [mixins.reactiveProp],
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this.addPlugin(ChartDataLabels)
    this.renderChart(this.chartData, this.options)
  }
}
</script>
